import { render, staticRenderFns } from "./ThreeBlock.vue?vue&type=template&id=37875b06"
import script from "./ThreeBlock.vue?vue&type=script&lang=js"
export * from "./ThreeBlock.vue?vue&type=script&lang=js"
import style0 from "./ThreeBlock.vue?vue&type=style&index=0&id=37875b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports